import EventCenterMapContainer from './components/EventCenterMapContainer';

export default EventCenterMapContainer;
